import { Box, Button, Flex, Input, SimpleGrid, Text } from '@chakra-ui/react'

import { FormField } from '../../../../components/FormField'
import { Icon } from '../../../../components/Icon'
import { MaskedInput } from '../../../../components/MaskedInput'
import { SectionTitle } from '../../../../components/SectionCard'
import { EMPTY_CONTACT, IAdmissionStepProps, IContactForm } from '../admissionForm'

/** The first contact is required; a second one is optional. */
export default function ContactsStep({ form, update, errors, isDisabled, mode = 'form' }: IAdmissionStepProps) {
  const required = mode === 'form'
  const contacts = form.emergency_contacts

  const change = (index: number, patch: Partial<IContactForm>) =>
    update({ emergency_contacts: contacts.map((contact, i) => (i === index ? { ...contact, ...patch } : contact)) })

  return (
    <>
      {contacts.map((contact, index) => {
        const error = (field: keyof IContactForm) => errors[`emergency_contacts.${index}.${field}`]

        return (
          <Box key={index} mt={index > 0 ? 8 : 0}>
            <SectionTitle
              actions={
                index > 0 && (
                  <Button
                    size="sm"
                    variant="ghost"
                    colorScheme="red"
                    leftIcon={<Icon name="lni lni-trash-can" />}
                    onClick={() => update({ emergency_contacts: contacts.slice(0, index) })}
                    isDisabled={isDisabled}
                  >
                    Remover
                  </Button>
                )
              }
            >
              {index === 0 ? '1º contato' : '2º contato'}
            </SectionTitle>
            <SimpleGrid columns={{ base: 1, md: 3 }} spacing={4}>
              <FormField label="Nome e sobrenome" error={error('name')} isRequired={required}>
                <Input
                  value={contact.name}
                  onChange={(e) => change(index, { name: e.target.value })}
                  isDisabled={isDisabled}
                />
              </FormField>
              <FormField label="Telefone" error={error('phone')} isRequired={required}>
                <MaskedInput
                  mask="phone"
                  value={contact.phone}
                  onChange={(phone) => change(index, { phone })}
                  isDisabled={isDisabled}
                />
              </FormField>
              <FormField label="Grau de parentesco" error={error('relationship')} isRequired={required}>
                <Input
                  value={contact.relationship}
                  onChange={(e) => change(index, { relationship: e.target.value })}
                  placeholder="Ex.: mãe, irmão, cônjuge"
                  isDisabled={isDisabled}
                />
              </FormField>
            </SimpleGrid>
          </Box>
        )
      })}

      {/* A group error: it belongs to no single field. */}
      {errors.emergency_contacts && (
        <Text color="red.500" fontSize="sm" mt={2}>
          {errors.emergency_contacts[0]}
        </Text>
      )}

      {contacts.length < 2 && (
        <Flex mt={6}>
          <Button
            size="sm"
            variant="outline"
            colorScheme="magenta"
            leftIcon={<Icon name="lni lni-plus" />}
            onClick={() => update({ emergency_contacts: [...contacts, EMPTY_CONTACT] })}
            isDisabled={isDisabled}
          >
            Adicionar 2º contato
          </Button>
        </Flex>
      )}
    </>
  )
}
